import axios from 'axios';
import util from '@/common/util';
import { searchRealTimeListings } from '@/common/search-request';
// just for get methods
// If the previous request has not ended, cancel
function cancel(fn) {
    const CancelToken = axios.CancelToken;
    return function(url, params) {
        if (this.axiosIns.cancel) {
            this.axiosIns.cancel();
        }
        const options = {
            params,
            cancelToken: new CancelToken(c => (this.axiosIns.cancel = c))
        };
        return fn.call(this, url, options).catch(err => {
            if (axios.isCancel(err)) {
                console.log('http request canceled');
            } else {
                throw err;
            }
        });
    };
}

// api-site/search/search-data
// https://wiki.chimeinc.com/pages/viewpage.action?pageId=40505163
export const fetchSearchData = async function(params) {
    return this.axiosIns
        .get('/api-site/search/search-data', {
            params
        })
        .then(res => res.data);
};
export const fetchCenterAllConditions = function(params) {
    if (!this.platform.isReallyUser) {
        return Promise.resolve({
            configs: [],
            locationPlaceholder: [],
            searchBarMappingStrategy: 0
        });
    }
    return this.axiosIns
        .get(`/api-site/search/center/conditions`, {
            params
        })
        .then(res => res.data);
};
export const fetchFilterItemOptions = function(params) {
    if (!this.platform.isReallyUser) {
        return Promise.resolve([]);
    }
    const { siteId, type } = params;
    return this.axiosIns
        .get(`/api-site/search/center/condition/options`, {
            params: {
                siteId,
                conditionName: (type && type.toLowerCase()) || ''
            }
        })
        .then(res => res.data);
};
export const getDefaultSuggestion = async function() {
    return this.axiosIns.get('/api-site/search/default-suggestion').then(res => res.data);
}
export const getSuggestions = function(url, params) {
    return this.axiosIns.get(url, params);
};

export const getListings = function(params, globalData) {
    params.timezone = this.getCookie('timezone') || util.getTimeZone();
    return searchRealTimeListings.call(this, { params, globalData });
};
export const fetchSuggestions = cancel(getSuggestions);
